"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var header_1 = __importDefault(require("@editorjs/header"));
var underline_1 = __importDefault(require("@editorjs/underline"));
var paragraph_1 = __importDefault(require("@editorjs/paragraph"));
var nested_list_1 = __importDefault(require("@editorjs/nested-list"));
exports.default = {
    /**
     * @type {EditorConfig.tools}
     */
    header: {
        class: header_1.default,
        config: {
            placeholder: "Tab \uC73C\uB85C \uD06C\uAE30\uB97C \uBCC0\uACBD\uD558\uC138\uC694.",
            levels: [1, 2, 3, 4],
            defaultLevel: 3,
        },
    },
    paragraph: {
        class: paragraph_1.default,
        inlineToolbar: true,
        config: {
            placeholder: "Tab \uC73C\uB85C \uC0C8\uB85C\uC6B4 \uBE14\uB85D\uC744 \uCD94\uAC00\uD558\uC138\uC694.",
            preserveBlank: true,
        },
    },
    list: {
        class: nested_list_1.default,
        inlineToolbar: true,
        config: {
            defaultStyle: 'unordered',
        },
    },
    underline: underline_1.default,
};
